import React from 'react';
import {
    withStyles,
    Typography,
    ListItem,
    Avatar,
    Grid,
    TextField,
    Button,
    ButtonBase,
    Divider,
} from '@material-ui/core';
import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import MSnackbar from '../view/MSnackbar';
import MSectionHeader from '../view/MSectionHeader';
import { withRouter } from 'react-router-dom';
import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';

const ICON_TJ = require("../../images/icons/tianjia_icon.png");

class Accusation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            value: '输入您要投诉的内容',
            roomId: '',
            filevalue: '',
            imageUrls: [],
        }
        console.log('Accusation', this.props);
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'Accusation');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    onClickAddImage = (target) => {
        console.log('onClickAddImage', target);
        if (this.state.images.length > 9) {
            return;
        }
        this.loadImg(target);
    }

    getObjectUrl = (file) => {
        var url = null;
        if (window.createObjectURL != undefined) { // basic
            url = window.createObjectURL(file);
        } else if (window.URL != undefined) { // mozilla(firefox)
            url = window.URL.createObjectURL(file);
        } else if (window.webkitURL != undefined) { // webkit or chrome
            url = window.webkitURL.createObjectURL(file);
        }
        return url;
    }

    loadImg = (target) => {
        if (target.files.length == 0) {
            return;
        }
        var file = target.files[0];
        let url = this.getObjectUrl(file);
        const { images } = this.state;
        images.push({ src: url });
        this.setState({ images: images });

        const reader = new FileReader();
        reader.onload = (e) => {
            this.updateImages(e.target.result);
        }
        reader.readAsArrayBuffer(file);
    }

    _handleChange = (value) => {
        if (value.length > 200) {
            return;
        }
        this.setState({ value: value });
    }

    updateImages = async (file) => {
        let result = await Apis.uploadImage(file, {});
        console.log('_onSubmit', result);
        if (result.code == 200) {
            let { imageUrls } = this.state;
            if (result.data) {
                imageUrls.push(result.data);
            }
            this.setState({ imageUrls: imageUrls })
        }
    }

    _onSubmit = () => {
        const { value } = this.state;
        if (value == '') {
            this.refs.toast.show('请输入内容！');
            return;
        }
        if (!AppData.me.isLogin()) {
            this.props.history.push('/login');
            return;
        }
        this.report();
    }

    report = async () => {
        const { value, imageUrls } = this.state;
        const { room_id } = this.props.match.params;
        let result = await Apis.encryptionRoomReport(room_id, value, JSON.stringify(imageUrls));
        if (result.code == 200) {
            if (result.data) {
                this.refs.toast.show('提交成功,我们会尽快给您处理！');
            } else {
                this.refs.toast.show('提交失败');
            }
        }
    }


    render() {
        const { classes } = this.props;
        const { images, value, filevalue } = this.state;
        return (
            <MBack title='房间举报'>
                <Grid container direction='row' style={{ height: 10 }}></Grid>
                <MSectionHeader title='图片证据(选填)' subtitle={images.length + '/9'} marginTop={8} marginBottom={8} />
                <Grid container direction='row' alignItems='center' style={{ width: '100vw', paddingLeft: 8, paddingRight: 8 }}>
                    {
                        images.map((item, i) => (
                            <img key={i} src={item.src} style={{ width: 60, height: 60, marginRight: 8 }}></img>
                        ))
                    }
                    <Grid container justify='center' alignItems='center' style={{ backgroundColor: '#E2E2E2', width: 60, height: 60 }}>
                        <img src={ICON_TJ} style={{ width: 18, height: 18 }}></img>
                        <input
                            id='imagefile'
                            title=''
                            type='file'
                            value={filevalue}
                            accept='image/*'
                            style={{ position: 'absolute', opacity: 0 }}
                            onChange={(e) => this.onClickAddImage(e.target)}
                        />
                    </Grid>
                </Grid>
                <Grid style={{ height: 1, backgroundColor: '#F7F7F7', width: '100%', marginTop: 8, marginBottom: 8 }}></Grid>
                <Grid container alignItems='center' justify='center' style={{ width: '100vw', paddingLeft: 8, paddingRight: 8, marginTop: 8 }}>
                    <textarea
                        value={value}
                        onChange={(e) => this._handleChange(e.target.value)}
                        style={{ width: 'calc(100% - 16px)', height: 100, color: '#888888', border: 'solid 0px' }} />
                    <MSectionHeader title='' subtitle={value.length + '/200'} />
                    <Grid style={{ height: 1, backgroundColor: '#F7F7F7', width: '100%' }}></Grid>
                </Grid>

                <Grid container justify='center' >
                    <ButtonBase className={classes.logoutBtn} onClick={() => this._onSubmit()} >提交</ButtonBase>
                </Grid>
                <MSnackbar ref='toast' />
            </MBack >
        );
    }
}
export default withRouter(withStyles((theme) => ({
    logoutBtn: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 22.5,
        color: 'white',
        height: 45,
        width: "80%",
        margin: theme.spacing(2, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
}))(Accusation));
